import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiImageGeneratorConfig } from '@/data/landingConfig/landingAiImageGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiImageGenerator } from './schemaObject';

interface Props {}
const AiImageGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiImageGenerator} />
			<LandingTemplate
				data={landingAiImageGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default AiImageGenerator;
